export default "__VITE_ASSET__01720bfe__"